export const POSITION_CLASSES = {
    static: 'static',
    fixed: 'fixed',
    absolute: 'absolute',
    relative: 'relative',
    sticky: 'sticky',
};
export const applyPositionInlineStyle = ({ top, bottom, left, right }) => {
    return Object.assign(Object.assign(Object.assign(Object.assign({}, (top && { top })), (bottom && { bottom })), (left && { left })), (right && { right }));
};
